import { Directive } from '@angular/core';

@Directive({
  selector: '[nttLabelLeading]',
})
export class NttLabelLeading {}
